// extracted by mini-css-extract-plugin
export default {"renderItem":"item-text-area-styles_renderItem__9YOHd"};